(function() {
  let currentStep = 0;
  let building = false;
  let firstLoad = true;
  let totalSteps = 0;
  let stepsLocked = false;
  let initialized = false;

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;


  let isScrolling = false;
  let scrollTimeout = null;

  if (isMobile) {
    window.addEventListener('scroll', () => {
      isScrolling = true;
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 500);
    }, { passive: true });
  }

  const stepNames = [
    'Diamond Shape',
    'Metal',
    'Hidden Stone',
    'Engraving',
    'Size',
    'Add to cart'
  ];

  function getNextStepName(currentIdx, total) {
    if (currentIdx >= total - 1) {
      return 'Add to cart';
    }
    return stepNames[currentIdx] || 'Next';
  }

  function initSizesShowMore() {
    if (isMobile) return;

    const wrappers = document.querySelectorAll('.finger-sizes .gpo-oos--show');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.showMoreInit) return;

      const items = wrapper.querySelectorAll('.gpo-radio');

      wrapper.dataset.showMoreInit = 'true';

      const visibleValues = [];
      for (let v = 4; v <= 8.5; v += 0.5) {
        visibleValues.push(v);
      }

      items.forEach((item) => {
        const valueStr = item.querySelector('input')?.value;
        const value = parseFloat(valueStr);

        if (!visibleValues.includes(value)) {
          item.classList.add('gpo-hidden-size');
        }
      });

      const hiddenCount = items.length - visibleValues.length;

      const showMoreBtn = document.createElement('button');
      showMoreBtn.type = 'button';
      showMoreBtn.className = 'gpo-show-more-btn';
      showMoreBtn.innerHTML = `Show more <span class="gpo-show-more-count">(+${hiddenCount})</span>`;
      
      wrapper.appendChild(showMoreBtn);

      showMoreBtn.addEventListener('click', () => {
        const isExpanded = wrapper.classList.toggle('gpo-expanded');

        if (isExpanded) {
          showMoreBtn.innerHTML = 'Show less';
        } else {
          showMoreBtn.innerHTML = `Show more <span class="gpo-show-more-count">(+${hiddenCount})</span>`;
        }
      });
    });
  }

  let sizesCheckInterval = null;

  function watchForSizesBlock() {
    if (isMobile) return;

    initSizesShowMore();

    if (!sizesCheckInterval) {
      sizesCheckInterval = setInterval(() => {
        initSizesShowMore();
      }, 500);

      setTimeout(() => {
        if (sizesCheckInterval) {
          clearInterval(sizesCheckInterval);
          sizesCheckInterval = null;
        }
      }, 30000);
    }
  }

  function updateSummaryBlock() {
    let summary = document.querySelector('.olvr-summary-block');
    
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'olvr-summary-block';
      const container = document.querySelector('.product__summary-block');
      if (container) {
        container.appendChild(summary);
      } else {
        document.body.appendChild(summary);
      }
    }

    const { title, options } = collectSelectedOptionsAndTitle();
    const price = getProductPrice();
    const soldOut = isVariantSoldOut();
    const soldOutLabel = soldOut ? '<span class="olvr-sold-out-label">Sold Out</span>' : '';
    const shareText = isMobile ? 'Share' : 'Share your design';

    summary.innerHTML = `
      <div class="olvr-summary-info">
        <div class="olvr-summary-title">${title} ${soldOutLabel}</div>
        ${options ? `<div class="olvr-summary-options">${options}</div>` : ''}
        <div class="olvr-summary-price">${price}<span class="olvr-summary-price-note">${isMobile ? 'Setting only' : 'Setting only · your diamond is next'}</span></div>
      </div>
      <div class="olvr-summary-actions">
        <button class="olvr-share-btn" aria-label="Share" type="button">
          <span class="share-label">${shareText}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"/>
          </svg>
        </button>
      </div>
    `;

    // Relocate the "Shipping calculated at checkout" + Shop Pay installment widget
    // from their original spot in the price block into the summary, below the price.
    if (!updateSummaryBlock._cachedTax) {
      updateSummaryBlock._cachedTax = document.querySelector('.product__tax') || null;
    }
    if (!updateSummaryBlock._cachedInstallment) {
      const installmentForm = document.querySelector('.product__info-container form.installment');
      updateSummaryBlock._cachedInstallment = installmentForm ? installmentForm.parentElement : null;
    }
    const summaryPriceEl = summary.querySelector('.olvr-summary-price');
    if (summaryPriceEl) {
      let cursor = summaryPriceEl;
      if (updateSummaryBlock._cachedTax) {
        cursor.after(updateSummaryBlock._cachedTax);
        cursor = updateSummaryBlock._cachedTax;
      }
      if (updateSummaryBlock._cachedInstallment) {
        cursor.after(updateSummaryBlock._cachedInstallment);
      }
    }
  }

  function cleanOptionText(text) {
    if (!text) return '';
    return text
      .replace(/Variant sold out or unavailable/gi, '')
      .replace(/sold out/gi, '')
      .replace(/unavailable/gi, '')
      .replace(/out of stock/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function collectSelectedOptionsAndTitle() {
    let title = '';
    const options = [];

    // Variant King 
    const kingSelected = document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"]');
    if (kingSelected) {
      title = kingSelected.getAttribute('data-value') || '';
    }

    if (!title) {
      const kingLi = document.querySelector('variant-king-combined-listing li[aria-checked="true"]');
      if (kingLi) {
        title = kingLi.getAttribute('aria-label') || kingLi.getAttribute('orig-value') || '';
      }
    }

    // Fallback
    if (!title) {
      title = document.querySelector('.product__title, .product-title, h1.title')?.textContent?.trim() || 'Product';
    }

    document.querySelectorAll('.product__info-container input[type="radio"]:checked, .product__info-container input[type="checkbox"]:checked').forEach(input => {
      if (input.closest('variant-king-combined-listing')) return;
      
      const label = input.closest('label') || document.querySelector(`label[for="${input.id}"]`);
      const text = cleanOptionText(label?.textContent || input.value);
      if (text && !options.includes(text)) options.push(text);
    });

    document.querySelectorAll('.product__info-container select').forEach(select => {
      if (select.value && select.selectedOptions[0]) {
        const text = cleanOptionText(select.selectedOptions[0].textContent);
        if (text && !options.includes(text)) options.push(text);
      }
    });

    document.querySelectorAll('.gpo-option-image.selected, .gpo-swatch.selected').forEach(el => {
      const text = cleanOptionText(el.getAttribute('title') || el.getAttribute('data-value') || el.textContent);
      if (text && !options.includes(text)) options.push(text);
    });

    return {
      title: cleanOptionText(title),
      options: options.length > 0 ? options.join(', ') : ''
    };
  }

  function isVariantSoldOut() {
    const submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return false;
    
    const btnText = submitBtn.textContent?.toLowerCase() || '';
    const isDisabled = submitBtn.disabled;
    
    return isDisabled && (btnText.includes('sold out') || btnText.includes('unavailable'));
  }

  function getProductPrice() {
    const priceSelectors = [ 
      '.price-item--regular',
      '.price__regular .price-item',
      '.product__price',
      '.price .money',
      '[data-product-price]',
      '.product-form__info-content .price',
      '.price-item'
    ];

    for (const selector of priceSelectors) {
      const el = document.querySelector(selector);
      if (el && el.textContent?.trim()) {
        return el.textContent.trim();
      }
    }

    return '';
  }

  function getProductTitle() {
    const kingSelected = document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"]');
    if (kingSelected) {
      const title = kingSelected.getAttribute('data-value');
      if (title) return title;
    }

    const kingLi = document.querySelector('variant-king-combined-listing li[aria-checked="true"]');
    if (kingLi) {
      const title = kingLi.getAttribute('aria-label') || kingLi.getAttribute('orig-value');
      if (title) return title;
    }

    // Fallback 
    const pageTitle = document.querySelector('.product__title, .product-title, h1.title')?.textContent?.trim();
    return pageTitle || 'Product';
  }

  function buildSteps(force = false) {

    if (isMobile && isScrolling && !force) return;
    
    if (building) return;
    building = true;

    const active = document.activeElement;
    let caretPos = null;
    const isEditable = active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.tagName === "SELECT");
    if (isEditable) {
      try { caretPos = active.selectionStart; } catch(e) {}
    }

    const container = document.querySelector('.product__info-container');
    if (!container) { building = false; return; }

    container.querySelectorAll('.olvr-step').forEach(w => w.children.length && w.replaceWith(...w.children));

    const steps = [];

    const wrap = el => {
      if (el.closest('.olvr-step')) return;
      const div = document.createElement('div');
      div.className = 'olvr-step';
      el.before(div);
      div.appendChild(el);
      steps.push(div);
    };

    const king = container.querySelector('variant-king-combined-listing');
    if (king && getComputedStyle(king).display !== 'none') {
      wrap(king);
    }

    if (king) {
      container.querySelectorAll('variant-selects fieldset, .gpo-options-group, .product-form__input, fieldset, div[id^="option-"]').forEach(el => {
        if (el.querySelector && el.querySelector('input, select, textarea, .gpo-option-image') &&
            !el.closest('.olvr-step') &&
            getComputedStyle(el).display !== 'none' &&
            getComputedStyle(el).visibility !== 'hidden' &&
            el.offsetHeight > 0) {
          wrap(el);
        }
      });
    }

    if (firstLoad && steps.length > 0) {
      totalSteps = steps.length;
      stepsLocked = true;
      firstLoad = false;
    } else if (!stepsLocked) {
      totalSteps = steps.length;
    }

    steps.forEach((s, i) => s.style.display = i === currentStep ? 'block' : 'none');

    const productForm = container.querySelector('.product-form');
    if (productForm) productForm.style.display = currentStep === totalSteps - 1 ? 'block' : 'none';

    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery) mediaGallery.classList.toggle('with-gallery__section', currentStep > 0);

    updateButtons(totalSteps);
    updateSummaryBlock();
    updateStepCounter();

    watchForSizesBlock();

    if (isEditable) {
      let restored = active.id ? document.getElementById(active.id) : document.querySelector(`[name="${active.name}"]`);
      if (restored) {
        restored.focus();
        if (caretPos !== null && restored.setSelectionRange) restored.setSelectionRange(caretPos, caretPos);
      }
    }

    building = false;
  }

  function updateButtons(total) {
    const prev = document.getElementById('step-prev');
    const next = document.getElementById('step-next');
    if (!prev || !next) return;

    prev.disabled = currentStep === 0;

    if (!initialized) {
      next.innerHTML = next.dataset.icon || '';
      next.disabled = true;
      next.classList.remove('olvr-final-submit');
      return;
    }

    const isLastStep = currentStep === total - 1;

    next.classList.toggle('olvr-final-submit', isLastStep);

    if (isLastStep) {
      const ctaLabel = document.getElementById('add-diamond-link') ? 'Choose Diamond' : 'Add to cart';
      next.innerHTML = `${ctaLabel} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      const realBtn = document.querySelector('.product-form__submit');
      next.disabled = realBtn?.disabled || (realBtn?.textContent || '').includes('Unavailable');
    } else {
      const nextStepName = 'Next';
      next.innerHTML = `${nextStepName} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      
      let filled = false;

      if (currentStep === 0) {
        filled = !!document.querySelector('variant-king-combined-listing .swatch-selected[current-product="true"], variant-king-combined-listing li[aria-checked="true"]');
        if (!filled) {
          const idInput = document.querySelector('input[name="id"]');
          filled = idInput && idInput.value && idInput.value !== '';
        }
      } else {
        const step = document.querySelectorAll('.olvr-step')[currentStep];
        const hasField = step?.querySelector('input, select, textarea');
        filled = !!hasField;
      }

      next.disabled = !filled;
      void next.offsetLeft;
    }
  }

  function updateStepCounter() {
    if (!initialized || totalSteps === 0) return;

    const steps = document.querySelectorAll('.olvr-step');
    const activeStep = steps[currentStep];
    if (!activeStep) return;

    // Remove ALL existing counters everywhere — avoids stale/duplicate spans
    document.querySelectorAll('.olvr-step-count').forEach(el => el.remove());

    // Pick the header element for this step.
    // GPO (engraving) step: use the whole .gpo-label so the counter lands
    // after the title text AND the info tooltip icon.
    let heading = activeStep.querySelector('.gpo-label');
    if (!heading) {
      heading = activeStep.querySelector(
        '.swatch-option-name, .form__label, legend'
      );
    }
    if (!heading) return;

    const counter = document.createElement('span');
    counter.className = 'olvr-step-count';
    counter.textContent = `${currentStep + 1}/${totalSteps + 1}`;
    heading.appendChild(counter);
  }

  document.getElementById('step-prev')?.addEventListener('click', () => {
    if (currentStep > 0) {
      currentStep--;
      buildSteps(true);
    }
  });

  document.getElementById('step-next')?.addEventListener('click', () => {
    if (currentStep < totalSteps - 1) {
      currentStep++;
      buildSteps(true);
    } else {
      const diamondLink = document.getElementById('add-diamond-link');
      if (diamondLink) {
        diamondLink.click();
      } else {
        document.querySelector('.product-form__submit:not([disabled])')?.click();
      }
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('.product__info-container')) {
      updateSummaryBlock();
  
      if (isMobile) {
        buildSteps(true);
      }
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.gpo-option-image, .gpo-swatch, variant-king-combined-listing')) {
      setTimeout(updateSummaryBlock, 100);
    
      if (isMobile) {
        setTimeout(() => buildSteps(true), 300);
      }
    } 
  });

  let lastHTML = '';
  let isHoveringTooltip = false;

  function isElementWithClosest(el) {
    return el instanceof Element || el instanceof HTMLElement;
  }

  document.addEventListener('mouseenter', (e) => {
    if (isElementWithClosest(e.target) &&
        e.target.closest('.variant-tooltip, .variant-option-title, [data-tooltip], .label-tooltip')) {
      isHoveringTooltip = true;
    }
  }, true);

  document.addEventListener('mouseleave', (e) => {
    if (isElementWithClosest(e.target) &&
        e.target.closest('.variant-tooltip, .variant-option-title, [data-tooltip], .label-tooltip')) {
      isHoveringTooltip = false;
    }
  }, true);

  if (!isMobile) {
    setInterval(() => {

      if (isHoveringTooltip) return;

      const vs = document.querySelector('variant-selects');
      if (!vs) return;

      if (vs.innerHTML !== lastHTML) {
        lastHTML = vs.innerHTML;
        buildSteps();
      }
    }, 250);
  }

  document.addEventListener('vkcl:variant:changed', () => {
    currentStep = 0;
    firstLoad = true;
    initialized = false;
    
    document.querySelectorAll('.gpo-oos--show').forEach(wrapper => {
      delete wrapper.dataset.showMoreInit;
      wrapper.classList.remove('gpo-expanded');
      const btn = wrapper.querySelector('.gpo-show-more-btn');
      if (btn) btn.remove();
      wrapper.querySelectorAll('.gpo-hidden-size').forEach(el => el.classList.remove('gpo-hidden-size'));
    });
    if (sizesCheckInterval) {
      clearInterval(sizesCheckInterval);
      sizesCheckInterval = null;
    }

    setTimeout(() => {
      buildSteps(true);
      initialized = true;
      updateButtons(totalSteps);
    }, 400);
  });

  function start() {
    if (!document.querySelector('.product-steps-nav')) return;

    const waiter = setInterval(() => {
      const king = document.querySelector('variant-king-combined-listing');
      if (king) {
        clearInterval(waiter);
        firstLoad = true;
        stepsLocked = false;
        initialized = false;
        lastHTML = document.querySelector('variant-selects')?.innerHTML || '';

        setTimeout(() => {
          buildSteps(true);
          stepsLocked = true;
          initialized = true;
          updateButtons(totalSteps);
          updateStepCounter();
        }, 1500);
      }
    }, 100);

    setTimeout(() => clearInterval(waiter), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();